import { fabric } from 'fabric'
import AnimationConstant from '@/constants/AnimationConstant'

const mixin = {
  methods: {
    createFrameDots () {
      const frameLines = []
      const { padding, height } = this.canvasDimensions

      const frameDots = []
      const { xs, ys, keyframeWidths } = this.canvasDimensions
      const radius = keyframeWidths.dot * 0.5
      const left = xs.firstKeyframeCenterX - radius
      for (let i = 0; i < AnimationConstant.MAX_FRAME_COUNT; i++) {
        const isMinor = i % 10
        const color = isMinor ? 'rgb(50,50,50)' : 'rgb(150,150,150)'

        const dot = new fabric.Circle({
          radius,
          fill: color,
          left: left + i * keyframeWidths.full,
          top: ys.keyframe.center,
          selectable: false,
          evented: false
        })
        frameDots.push(dot)

        if (this.enableDebugging) {
          const x = padding + i * keyframeWidths.full
          const line = new fabric.Line([x, height, x, height - (isMinor ? 24 : 36)], {
            stroke: color,
            strokeWidth: 1,
            selectable: false,
            evented: false
          })
          frameLines.push(line)
        }
      }
      if (this.enableDebugging) {
        this.addToCanvas(frameLines)
      }

      this.addToCanvas(frameDots)
      this.canvasFrameDots = frameDots

      this.updateFrameDots()
    },

    updateFrameDots () {
      // TODO Update lines if debugging

      const { xs, keyframeWidths } = this.canvasDimensions
      const radius = keyframeWidths.dot * 0.5
      const left = xs.firstKeyframeCenterX - radius
      const rangeDelta = this.frameRangeDelta
      const skipInterval = rangeDelta > 1 ? Math.floor(rangeDelta / 50) + 1 : 1
      let i = 0
      for (const dot of this.canvasFrameDots) {
        dot.radius = radius
        dot.left = left + i * skipInterval * keyframeWidths.full
        dot.setCoords()
        i++
      }
    }
  }
}

export default mixin
